/**
 * Feature-flag reader — Epic 48 Phase 02, D-CUTOVER-1 (2026-08-26).
 *
 * No flag mechanism existed in this codebase before this file. It exists for exactly one
 * reason: the new workspace shell (`pages/workspace/WorkspacePage.tsx`) and the shipped
 * 5-tab `CampaignDashboardPage` must be able to sit on the SAME `/campaigns/:id` route at
 * the same time, so the new shell can be built and reviewed incrementally without breaking
 * the product every agencies use today. Cut-over (retiring the flag and the old page) is
 * Phase 11's job, not this one's.
 *
 * Follows the `import.meta.env` convention already established by `lib/api-client.ts`
 * (`VITE_API_URL`, `VITE_WS_ENABLED`): a build-time constant, read once at module load —
 * not a runtime toggle, not a remote config, not a per-user override. Unlike `VITE_WS_ENABLED`
 * (default ON, opt OUT), this flag defaults OFF — an unfinished, flag-gated surface must not
 * become live by omission.
 */
export const WORKSPACE_SHELL_ENABLED: boolean =
  import.meta.env['VITE_WORKSPACE_SHELL_ENABLED'] === 'true'
